export const DeactivatedAlert = () => {
  return (
    <div className='text-display-xs font-semibold flex justify-between bg-secondary-brand-25 rounded-2xl p-6 shadow-sm'>
      This organization is no longer available on the MovingWorlds platform.
    </div>
  );
};
